import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import Loader from "./Loader"
import Toolbar from "./Toolbar"
import Products from "./Products"
import LoadMore from "./LoadMore"
import NoResults from "./NoResults"
import { useEffect, useState } from "preact/hooks"

export default function () {
    const { response, loading } = useAppState();
    const foundProducts = response?.products && response?.products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    
    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen);
    }

    useEffect(() => {
        const h1El = document.querySelector('.nosto-search-h1');
        if(h1El && response?.query && response?.products?.total) {
            h1El.textContent = `Search results for "${response?.query}"`
            document.title = `Search: ${response?.products?.total} results for "${response?.query}" - Spongellé`
        } else {
            h1El.textContent = "Search results"
        }
    }, [response?.query, response?.products?.total])

    useEffect(() => {
        const searchbarEl = document.getElementById('serp-searchbar');
        if(searchbarEl && searchbarEl.classList.contains('hidden')) {
            searchbarEl.classList.remove('hidden');
        }
    }, [])

    return (
        <div class="ns-serp max-w-[1112px] mx-auto" data-nosto-element="search">
            {(loading && !foundProducts) ? (
                <Loader />
            ) : foundProducts ? (
                <>
                    <Toolbar 
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                    <Products />
                    <LoadMore />
                </>
            ) : (
                <NoResults />
            )}
        </div>
    )
}
